import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { MainLayout } from "@/layouts";
import { MainScreenContact, StartConversation, SupportPartner } from "@/pagePartials/contact";

const Contact = () => {
  return (
    <GoogleReCaptchaProvider
      reCaptchaKey="6Le_NVQiAAAAAICg36Gi-LIbY9IbaXORJl0eVCop"
      scriptProps={{
        async: false,
        defer: false,
        appendTo: "head",
        nonce: undefined,
      }}
    >
      <MainLayout
        bgTheme="var(--background-light)"
        navbarTheme="light"
        title="Free Trial"
        description="Contact is a page where the client can contact an advisor to know about the product/services"
      >
        <MainScreenContact />
        <SupportPartner name="Olivier Lüscher" email="Email: o.luescher@cellectenergy.com" position="expert" image="/assets/contact/support/expert.png" />
        <SupportPartner
          name="Llorenç Garcia Ibars"
          email="Email: l.garcia@cellectenergy.com"
          position="specialist"
          image="/assets/contact/support/specialist.png"
        />
        <StartConversation />
      </MainLayout>
    </GoogleReCaptchaProvider>
  );
};

export default Contact;
